export const getRoutesRespMaritime = () => {
  return {
    routes: [
      {
        origin: "JPYOK",
        destination: "CAPRR",
      },
      {
        origin: "CAVAN",
        destination: "CNNSA",
      },
      {
        origin: "MYTPP",
        destination: "GHTEM",
      },
      {
        origin: "NGLOS",
        destination: "NGWAR",
      },
      {
        origin: "SGSIN",
        destination: "CMKBI",
      },
      {
        origin: "USORF",
        destination: "USSAV",
      },
      {
        origin: "KRBNP",
        destination: "CAVAN",
      },
      {
        origin: "IDJKT",
        destination: "PGMAG",
      },
      {
        origin: "USLGB",
        destination: "NZAKL",
      },
      {
        origin: "ESALG",
        destination: "USNYC",
      },
      {
        origin: "NGLOS",
        destination: "CIABJ",
      },
      {
        origin: "AUTSV",
        destination: "MYKBK",
      },
      {
        origin: "MYTPP",
        destination: "SGSIN",
      },
      {
        origin: "LKCMB",
        destination: "CGPNR",
      },
      {
        origin: "GHTEM",
        destination: "TGLFW",
      },
      {
        origin: "USSAV",
        destination: "EGALY",
      },
      {
        origin: "NZTRG",
        destination: "USSEA",
      },
      {
        origin: "RUNVS",
        destination: "UAODS",
      },
      {
        origin: "CAMNI",
        destination: "NLRTM",
      },
      {
        origin: "CNSGH",
        destination: "CNNGB",
      },
      {
        origin: "SGSIN",
        destination: "CNSGH",
      },
      {
        origin: "PANAMA CANAL",
        destination: "YOKOHAMA",
      },
    ],
  };
};
